const ArrowButton = props => (
  <svg viewBox='0 0 61 23' {...props}>
    <line x1='0.128906' y1='11.4299' x2='57.6602' y2='11.4299' stroke='#FFE42B' strokeWidth='2' />
    <path d='M48.5703 21.5374L58.5338 11.5738L48.5703 1.6103' stroke='#FFE42B' strokeWidth='2' fill={'none'} />
  </svg>
)

export default ArrowButton



// WEBPACK FOOTER //
// ./components/icons/arrow-button.js